/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.admin.Attribute', null, global);
goog.exportSymbol('proto.admin.Category', null, global);
goog.exportSymbol('proto.admin.CategoryDescriptor', null, global);
goog.exportSymbol('proto.admin.CategoryDescriptor.AttributeDescriptor', null, global);
goog.exportSymbol('proto.admin.Picker', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.CategoryDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.CategoryDescriptor.repeatedFields_, null);
};
goog.inherits(proto.admin.CategoryDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.CategoryDescriptor.displayName = 'proto.admin.CategoryDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.CategoryDescriptor.AttributeDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.CategoryDescriptor.AttributeDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.CategoryDescriptor.AttributeDescriptor.displayName = 'proto.admin.CategoryDescriptor.AttributeDescriptor';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.CategoryDescriptor.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.CategoryDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.CategoryDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.CategoryDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.CategoryDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    parent: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rank: jspb.Message.getFieldWithDefault(msg, 5, 0),
    synonymsList: jspb.Message.getRepeatedField(msg, 6),
    attributesList: jspb.Message.toObjectList(msg.getAttributesList(),
    proto.admin.CategoryDescriptor.AttributeDescriptor.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.CategoryDescriptor}
 */
proto.admin.CategoryDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.CategoryDescriptor;
  return proto.admin.CategoryDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.CategoryDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.CategoryDescriptor}
 */
proto.admin.CategoryDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Category} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {!proto.admin.Category} */ (reader.readEnum());
      msg.setParent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addSynonyms(value);
      break;
    case 7:
      var value = new proto.admin.CategoryDescriptor.AttributeDescriptor;
      reader.readMessage(value,proto.admin.CategoryDescriptor.AttributeDescriptor.deserializeBinaryFromReader);
      msg.addAttributes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.CategoryDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.CategoryDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.CategoryDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.CategoryDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getParent();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSynonymsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.admin.CategoryDescriptor.AttributeDescriptor.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.CategoryDescriptor.AttributeDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.CategoryDescriptor.AttributeDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attribute: jspb.Message.getFieldWithDefault(msg, 2, 0),
    picker: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.CategoryDescriptor.AttributeDescriptor}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.CategoryDescriptor.AttributeDescriptor;
  return proto.admin.CategoryDescriptor.AttributeDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.CategoryDescriptor.AttributeDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.CategoryDescriptor.AttributeDescriptor}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.admin.Attribute} */ (reader.readEnum());
      msg.setAttribute(value);
      break;
    case 3:
      var value = /** @type {!proto.admin.Picker} */ (reader.readEnum());
      msg.setPicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.CategoryDescriptor.AttributeDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.CategoryDescriptor.AttributeDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttribute();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPicker();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Attribute attribute = 2;
 * @return {!proto.admin.Attribute}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.getAttribute = function() {
  return /** @type {!proto.admin.Attribute} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.admin.Attribute} value */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.setAttribute = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Picker picker = 3;
 * @return {!proto.admin.Picker}
 */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.getPicker = function() {
  return /** @type {!proto.admin.Picker} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.admin.Picker} value */
proto.admin.CategoryDescriptor.AttributeDescriptor.prototype.setPicker = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Category category = 1;
 * @return {!proto.admin.Category}
 */
proto.admin.CategoryDescriptor.prototype.getCategory = function() {
  return /** @type {!proto.admin.Category} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Category} value */
proto.admin.CategoryDescriptor.prototype.setCategory = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Category parent = 2;
 * @return {!proto.admin.Category}
 */
proto.admin.CategoryDescriptor.prototype.getParent = function() {
  return /** @type {!proto.admin.Category} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.admin.Category} value */
proto.admin.CategoryDescriptor.prototype.setParent = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.admin.CategoryDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.CategoryDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slug = 4;
 * @return {string}
 */
proto.admin.CategoryDescriptor.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.CategoryDescriptor.prototype.setSlug = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 rank = 5;
 * @return {number}
 */
proto.admin.CategoryDescriptor.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.admin.CategoryDescriptor.prototype.setRank = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated string synonyms = 6;
 * @return {!Array<string>}
 */
proto.admin.CategoryDescriptor.prototype.getSynonymsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.admin.CategoryDescriptor.prototype.setSynonymsList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.CategoryDescriptor.prototype.addSynonyms = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.CategoryDescriptor.prototype.clearSynonymsList = function() {
  this.setSynonymsList([]);
};


/**
 * repeated AttributeDescriptor attributes = 7;
 * @return {!Array<!proto.admin.CategoryDescriptor.AttributeDescriptor>}
 */
proto.admin.CategoryDescriptor.prototype.getAttributesList = function() {
  return /** @type{!Array<!proto.admin.CategoryDescriptor.AttributeDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.CategoryDescriptor.AttributeDescriptor, 7));
};


/** @param {!Array<!proto.admin.CategoryDescriptor.AttributeDescriptor>} value */
proto.admin.CategoryDescriptor.prototype.setAttributesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.admin.CategoryDescriptor.AttributeDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.CategoryDescriptor.AttributeDescriptor}
 */
proto.admin.CategoryDescriptor.prototype.addAttributes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.admin.CategoryDescriptor.AttributeDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.CategoryDescriptor.prototype.clearAttributesList = function() {
  this.setAttributesList([]);
};


/**
 * @enum {number}
 */
proto.admin.Attribute = {
  ATTRIBUTE_UNKNOWN: 0,
  ACCEPTS_DIE_SIZE: 1,
  ACCESSORIES_ATTRIBUTE: 2,
  ACTION: 3,
  ADJ_SIZE: 4,
  ADJUSTMENT_SIZE: 5,
  AFT_CIRCUIT: 6,
  AIRLINE_APPROVED: 7,
  AMMO_TYPE: 8,
  ANSI_NEDA: 9,
  ANSI_RATING: 10,
  APPLICATION: 11,
  AUDIBLE_OR_MOTION: 12,
  AUTO_RESETTING: 13,
  BARREL_DESCRIPTION: 14,
  BARREL_FINISH: 15,
  BARREL_LENGTH_RANGE: 16,
  BARREL_LENGTH: 17,
  BARREL_MATERIAL: 18,
  BARREL_TYPE: 19,
  BASE_MATERIAL: 20,
  BATTERY_LIFE: 21,
  BATTERY: 22,
  BIT_TYPE: 23,
  BLADE_LENGTH: 24,
  BLADE_MATERIAL: 25,
  BLADE_TYPE: 26,
  BLIND_MATERIAL: 27,
  BODY_DIAMETER: 28,
  BODY_TYPE: 29,
  BOXES_PER_CASE: 30,
  BRISTLE_TYPE: 31,
  BTU: 32,
  BULB_TYPE: 33,
  BULLET_TYPE: 34,
  BULLET_WEIGHT: 35,
  BUSHINGS: 36,
  CALIBER_ATTRIBUTE: 37,
  CAPACITY: 38,
  CASE_TYPE: 39,
  CASE: 40,
  CASING_MATERIAL: 41,
  CHAMBER: 42,
  CHARGE_TIME: 43,
  CHEMICAL_COMPOSITION: 44,
  CHOKE_CONFIGURATION: 45,
  CHOKES_INCLUDED: 46,
  CLOSE_FOCUS: 47,
  CLOSED_LENGTH: 48,
  COATING_TYPE: 49,
  COCKING_TYPE: 199,
  COLOR_ATTRIBUTE: 200,
  COMBO_TYPE: 50,
  COMPRESSION_CIRCUIT: 51,
  CONFIGURATION: 52,
  CONTROLS: 53,
  DESCRIPTION: 54,
  DIAMETER: 55,
  DIMENSIONS: 56,
  DIOPTER_ADJUSTMENT: 57,
  DOT_SIZE: 58,
  ECO_FRIENDLY: 59,
  EDGE_TYPE: 60,
  ENHANCEMENT_COLOR: 61,
  EXIT_PUPIL_DIAMETER: 62,
  EYE_RELIEF: 63,
  EYEGLASS_FRIENDLY: 64,
  FIELD_OF_VIEW: 65,
  FILTER_COLOR: 66,
  FINISH: 67,
  FLOATABLE: 68,
  FOCUS_RANGE: 69,
  FOCUS_TYPE: 70,
  FOR_SERIES: 71,
  FRAME_COLOR: 72,
  FRAME_FINISH: 73,
  FRAME_MATERIAL: 74,
  FRAME_TYPE: 75,
  FRAME: 76,
  FUNCTION: 77,
  GAUGE: 78,
  GENERATION: 79,
  GRIPS: 80,
  GUN_CALIBER: 81,
  GUN_MODEL: 82,
  GUN_TYPE: 83,
  HAND: 84,
  HANDGUARD_FINISH: 85,
  HANDGUARDS: 86,
  HANDLE_DESCRIPTION: 87,
  HARDWARE: 88,
  HEAD_DIAMETER: 89,
  HEATING_AREA: 90,
  HEIGHT: 91,
  HOLES: 92,
  ILLUSTRATION: 93,
  IMPACT_ENHANCEMENT: 94,
  INCLUDES: 95,
  INFRARED_ILLUMINATOR: 96,
  INTENSIFIER_TUBE: 97,
  LENGTH: 98,
  LENS_COATING: 99,
  LENS_COLOR: 100,
  LENS_TYPE: 101,
  LINKAGE_MATERIAL: 102,
  LOCKABLE: 103,
  MAGNIFICATION: 104,
  MATERIAL_FINISH: 105,
  MATERIAL: 106,
  MAX_DISTANCE: 107,
  METAL_FINISH_GROUP: 108,
  METAL_FINISH: 109,
  MIN_DISTANCE: 110,
  MODEL_FIT: 111,
  MODEL_OR_STYLE: 112,
  MODEL: 113,
  MOTOR_TYPE: 114,
  MOTOR: 115,
  MOUNT_TYPE: 116,
  MOUNT: 117,
  MUZZLE_ENERGY: 118,
  MUZZLE_VELOCITY: 119,
  MUZZLE: 120,
  NO_OF_BLADES: 121,
  NO_OF_PIECES: 122,
  NOMINAL_VOLTAGE: 123,
  NOSE_PIECE: 124,
  NRR: 125,
  OBJECTIVE: 126,
  OPEN_LENGTH: 127,
  OPEN_TYPE: 128,
  OPTIC_COATING: 129,
  OUTPUT: 130,
  OVERALL_LENGTH: 131,
  PADDING: 132,
  PARALLAX_ADJUSTMENT: 133,
  POLARIZED: 134,
  PRESSURIZED: 135,
  PRISM_TYPE: 136,
  PROGRESSIVE_SINGLE: 137,
  PROOFS: 138,
  PROTECTS: 139,
  QUANTITY: 140,
  RAM_SIZE: 141,
  RATED_CAPACITY_MAH: 142,
  RATING: 143,
  RECEIVER_DESCRIPTION: 144,
  RECEIVER_FINISH: 145,
  RECEIVER_MATERIAL: 146,
  RECHARGEABLE: 147,
  RELEASE_TYPE: 148,
  REMOTE_CONNECTS: 149,
  REMOTE_RANGE: 150,
  RESOLUTION: 151,
  RETICLE: 152,
  ROUNDS_PER_BOX: 153,
  RUN_TIME: 154,
  SAFETY: 155,
  SCOPE_MODEL: 156,
  SEASON: 157,
  SEAT_ACCEPTABLE: 158,
  SEAT_TYPE: 159,
  SHARPENER_MATERIAL: 160,
  SHARPENER_TYPE: 161,
  SHEATH: 162,
  SHORT_FOCUS: 163,
  SIGHT_CONFIGURATION: 164,
  SIGHT_STYLE: 165,
  SIGHTS: 166,
  SINGLE_DOUBLE_ARM: 167,
  SIZE: 168,
  SLIDE_DESCRIPTION: 169,
  SPECIES: 170,
  STATIONS: 171,
  STEEL_TYPE: 172,
  STOCK_DESCRIPTION: 173,
  STOCK_FINISH_GROUP: 174,
  STYLE: 175,
  SUITABLE_FOR: 176,
  SWITCH_TYPE: 177,
  TARGET_COLOR: 178,
  TARGET_DISTANCE: 179,
  TARGET_TYPE: 180,
  TEMPLE_SLEEVES: 181,
  THREAD_PATTERN: 182,
  THREADS: 183,
  TIP_FEATURE: 184,
  TREATMENT: 185,
  TRIGGER_TYPE: 186,
  TRIGGER: 187,
  TUBE_DIAMETER: 188,
  TWILIGHT_FACTOR: 189,
  TWIST: 190,
  TYPE: 191,
  UV_RATING: 192,
  VOLT: 193,
  WEIGHT_CAPACITY: 194,
  WEIGHT_RANGE: 195,
  WEIGHT: 196,
  WIDTH: 197,
  WINDAGE_ELEVATION: 198
};

/**
 * @enum {number}
 */
proto.admin.Category = {
  CATEGORY_UNKNOWN: 0,
  ACCESSORIES: 1,
  BATTERIES: 2,
  CLEANING: 3,
  FIREARM_ACCESSORIES: 4,
  KNIFE_ACCESSORIES: 5,
  LIGHTS: 6,
  OPTICS_ACCESSORIES: 7,
  TOOLS: 8,
  AMMUNITION: 9,
  FIREARMS: 10,
  LOWERS: 11,
  HANDGUNS: 12,
  RIFLES: 13,
  SHOTGUNS: 14,
  UPPERS: 15,
  KNIVES: 16,
  OPTICS: 17,
  BINOCULARS: 18,
  NIGHT_VISION: 19,
  RANGE_FINDERS: 20,
  RED_DOT_SCOPES: 21,
  SCOPES: 22,
  SPOTTING_SCOPES: 23,
  SHOOTING: 24,
  BORE_SIGHTERS_AND_ARBORS: 25,
  CARRYING_BAGS: 26,
  EYE_PROTECTION: 27,
  HEARING_PROTECTION: 28,
  TARGETS: 29,
  TRAPS_AND_CLAY_THROWERS: 30,
  UTILITY_BOXES: 31,
  SUPPRESSORS: 32
};

/**
 * @enum {number}
 */
proto.admin.Picker = {
  PICKER_UNKNOWN: 0,
  COLOR: 1,
  BOOLEAN: 2,
  CALIBER: 3
};

goog.object.extend(exports, proto.admin);
